<palantir-content class="palantir-accordion" [ngClass]="{ 'palantir-accordion--open': isOpen() }">
  <div class="palantir-accordion__header" (click)="toggleOpen()">
    <div class="w-full flex justify-between">
      <span>
        <palantir-text title="title">{{ warranty.name }} </palantir-text> -
        <palantir-text title="description"> {{ warranty.value + warranty.extendedValue | currencyFormat }}</palantir-text>
      </span>
      <palantir-tag [color]="tag().color">{{ tag().label }}</palantir-tag>
    </div>
    <palantir-icon name="expand-more-outline"></palantir-icon>
  </div>

  <div class="palantir-accordion__body" [@expandCollapse]="isOpen() ? 'expanded' : 'collapsed'">
    <div class="palantir-accordion__content">
      <ng-content></ng-content>
    </div>
  </div>
</palantir-content>
